import React, { CSSProperties, ReactNode } from 'react';
import '../css/heroContent.css';
import RoundButton from '../../../button/round-button/ts/roundButton';

interface HeroContentProps {
  titleLine1?: string;
  titleLine2?: string;
  buttonText?: string;
  buttonIcon?: ReactNode;
  buttonIconPosition?: 'left' | 'right';
  onButtonClick?: () => void;
  className?: string;
  btnVisible?: boolean;
  styleInject?: CSSProperties;
  buttonStyle?: CSSProperties;
}

const HeroContent: React.FC<HeroContentProps> = ({
  titleLine1,
  titleLine2,
  buttonText = 'Learn More',
  buttonIcon,
  buttonIconPosition = 'right',
  onButtonClick,
  className = '',
  styleInject,
  buttonStyle,
  btnVisible
}) => {

  const styleVaribleHero = {
    '--hero-content-hero-text-color': styleInject?.color,
    '--hero-content-hero-text-weight': styleInject?.fontWeight,
    '--hero-content-hero-text-font-style': styleInject?.fontStyle,
    '--hero-content-hero-text-font-size': styleInject?.fontSize,
  } as CSSProperties

  return (
    <div className={`scl--web-component-hero-content ${className}`}>
      <h1 className="scl--web-component-hero-title" style={styleVaribleHero}>
        <span className="scl--web-component-hero-title-line1" >{titleLine1}</span>
        <span className="scl--web-component-hero-title-line2">{titleLine2}</span>
      </h1>
      {btnVisible &&
        <RoundButton
          text={buttonText}
          icon={buttonIcon}
          showIcon={!!buttonIcon}
          iconPosition={buttonIconPosition}
          onClick={onButtonClick}
          className="scl--web-component-hero-button"
          styleInjectButton={buttonStyle}
        />
      }

    </div>
  );
};

export default HeroContent;
